<template>
  <base-tooltip
    :distance="5"
    placement="bottom-end"
  >
    <template #default="{ trigger }">
      <div
        :ref="trigger"
        :class="$style.hideButton"
      >
        <base-icon
          :class="$style.hideButtonIcon"
          type="x-close"
          v-bind="$attrs"
        />
      </div>
    </template>

    <template #content>
      {{ i18n('hide') }}
    </template>
  </base-tooltip>
</template>

<script setup lang="ts">
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import { useI18N } from '@/shared/legacy/lib/use-i18n';
import BaseTooltip from '@/shared/legacy/ui/base-tooltip/base-tooltip.vue';

defineOptions({
  inheritAttrs: true
});

const i18n = useI18N();
</script>

<i18n lang="json">
{
  "hide": {
    "ru_RU": "Скрыть из списка",
    "en_US": "Hide from list"
  }
}
</i18n>

<style module>
.hideButton {
  margin-top: 2px;
  margin-left: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  cursor: pointer;

  opacity: 0.3;
  transition: opacity 0.1s linear;

  &:hover {
    opacity: 0.45;
  }
}
.hideButtonIcon {
  color: $vantaBlackColor;
}
</style>
